<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      scale:0,
    }
  },
  watch:{
    scale() {
      window.onresize = function () {
        console.log('变化了')
         this. setScale()
          
      };
    }
  },
   mounted(){
    // this.setSize()

   },
   methods:{
    setSize() {
      let designWidth = 1920;//设计稿的宽度，根据实际项目调整
      let designHeight = 1080;//设计稿的高度，根据实际项目调整
      let scale = document.documentElement.clientWidth/document.documentElement.clientHeight < designWidth/designHeight ? 
          (document.documentElement.clientWidth / designWidth):
          (document.documentElement.clientHeight / designHeight);
          this.scale = scale
      document.querySelector('#app').style.transform = `scale(${scale}) translate(-50%)`;
      console.log(scale,'scale')
    }
   }
}
</script>
<style lang="scss">
html {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    font-size: 10px;  // 相当于1rem = 10px
}
body {
    width: 100%;
    height: 100%;
    min-height: 100%;
    padding: 0;
    margin: 0;
    font-size: 16px;
    overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  overflow: hidden;
  height: 100vh;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
 <style>
 /* ::-webkit-scrollbar {
   width: 0 !important;
 }
 ::-webkit-scrollbar {
   width: 0 !important;height: 0;
 } */
 </style>
